import React from 'react';

import { CircularProgress } from 'material-ui/Progress';
import { withStyles } from 'material-ui/styles';

const styles = theme => ({
    progress: {
        margin: `0 ${theme.spacing.unit * 2}px`,
    },
    center: {
        textAlign: 'center',
        marginTop: 50,
    }
});

class Spinner extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isShow: this.props.isLoading
        };
    }

    render() {
        const { classes } = this.props;
        return (
            this.state.isShow
                ? <div className={classes.center}>
                    <CircularProgress className={classes.progress} style={{ color: '#25bdae' }}/>
                </div>
                : null
        );
    }
}

export default withStyles(styles)(Spinner);



// WEBPACK FOOTER //
// ./src/components/spinner/index.js